//global
$.ajaxSetup({
	cache: false // Disable caching of AJAX responses
});

var aptAjax = (function ($: JQueryStatic) {

	/** AJAX error handling
	* @param {string} event Contains the event object
	* @param {string} jqXHR Contains the XMLHttpRequest object
	* @param {string} settings Contains the settings used in the AJAX request
	* @param {string} thrownError Contains the JavaScript exception, if one occurred
	*/
	$(document).ajaxError(function (event: JQuery.TriggeredEvent, jqXHR: JQuery.jqXHR, settings: JQuery.AjaxSettings, thrownError: string) {
		if (jqXHR.status === 401) aptUtils.logoff();
		if (settings.url !== undefined && settings.url.indexOf("ClientLogging") > -1) return;
		const url = siteUrl.concat("/ClientLogging/LogErrorPSSWebID");
		let log = "<thrownError>" + thrownError + "</thrownError>\n";
		log += "<jqxhrStatus>" + jqXHR.status + "</jqxhrStatus>\n";
		if (settings.url !== undefined) log += "<url>" + encodeURIComponent(settings.url) + "</url>\n";
		if (settings.method !== undefined) log += "<method>" + settings.method + "</method>\n";
		if (settings.dataType !== undefined) log += "<dataType>" + settings.dataType + "</dataType>\n";
		log += "<jqxhrStatusText>" + jqXHR.statusText + "</jqxhrStatusText>\n";
		log += "<jqxhrResponseText>" + jqXHR.responseText + "</jqxhrResponseText>\n";
		if (settings.data !== undefined) log += "<data>" + settings.data + "</data>\n";
		_request({
			url: url,
			data: { msg: log, webid: apt.sm.webId, className: 'aptAjax', method: 'ajaxError' }
		}).fail(function (xhr: any, textStatus: string, errorThrown: string) {
			console.log(errorThrown);
		});
	});
	
	function _request(options: APTAjaxOptions) {
		const _isAsync: boolean = options.async || true;
		const _dataType: string = options.dataType || "json";
		const _method: string = options.method || "POST";
		const _token: JQuery.PlainObject = { __RequestVerificationToken: $("input[name='__RequestVerificationToken']").val() as string };

		let _contentType: string | boolean;
		if (options.contentType == null || options.contentType == "undefined") _contentType = "application/x-www-form-urlencoded; charset=UTF-8";
		else _contentType = options.contentType;

		options.data = $.extend(options.data, _token);

		const request = jQuery.ajax({
			async: _isAsync,
			method: _method,
			dataType: _dataType,
			url: options.url,
			contentType: _contentType,
			data: options.data,
			processData: options.processData
		});

		if (options.done) request.done((options.done));
		if (options.fail) request.fail((options.fail));
		if (options.always) request.always((options.always));

		if (options.waitIndicator) {
			$(request).on("beforeSend", function () { $(options.waitIndicator).show(); });

			request.always(function () {
				$(options.waitIndicator).hide();
			});
		}

		return request;
	}

	/** 
	* Loads a partial view into an HTML element using ajax.
	* Essentially JQuery.load() but with more transparency for debugging
	* and options for data vs query string parameters.
	*/
	function _loadAction(url: string, data: any, element: JQuery<HTMLElement>) {
		let request = aptAjax.request({
			url: url,
			data: data,
			dataType: "html",
			method: "GET",
			done: function (data) {
				element.html(data);
			},
			fail: function (jqXHR, textStatus, errorThrown) {
				console.log(errorThrown);
				alert("An internal error has occurred.");
			}
		});
		return request;
	}

	interface APTAjaxOptions<TContext = any> extends JQuery.AjaxSettings<TContext> {
		waitIndicator?: HTMLElement | string | any;
		done?: (data: any, textStatus: JQuery.Ajax.SuccessTextStatus, jqXHR: JQuery.jqXHR) => void;
		fail?: (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus | null, errorThrown: string) => void;
		always?: (data: any | JQuery.jqXHR, textStatus: JQuery.Ajax.TextStatus, errorThrown: JQuery.jqXHR | string) => void;
	}

	return {
		request: _request,
		loadAction: _loadAction
	}
})($);
